
import { transfCssUtil } from '../../utils/index'

export default {
  text (h, conf, key) {
    // return <span class="mobile-main-title">{ conf.__slot__[key] }</span>
    const isEditMode = this.mode === 'fastSite'
    const changeKey = '__slot__.' + key
    return <span class="mobile-main-title">
      <TextEdit
        change-key={changeKey}
        v-model={conf.__slot__[key]}
        mode={isEditMode}
        isSingle
        conf={conf}
        sendData={conf.__slot__[key]}
        {...{ on: this.$listeners }}
      />
    </span>
  },
  video (h, conf, key) {
    
    const style = conf.style
    const videoStyle = transfCssUtil(style)
    return <video
      key={'video_' + conf.__config__.renderKey}
      width="100%"
      style= {
        {
          borderRadius: videoStyle.borderRadius,
        }
      }
      height={style.height}
      poster={style.poster}
      autoplay={conf.__slot__['autoplay']}
      controls={ conf.__slot__['controls'] === undefined ? true : conf.__slot__['controls'] }
      loop={ conf.__slot__['loop'] }
      muted={ true }
      src={ conf.__slot__[key] }
    />
  }
}